<template src="../../../../components/shared/contacts/ViewContactTemplate.html">

</template>

<script>
    import GenericUserInfo from "../../../../components/shared/GenericUserInfo.vue";
    import GenericProfileInfo from "../../../../components/shared/GenericProfileInfo.vue";
    import {api} from "../../../../global/framework/api.js";

    export default {
        name: "ViewContactModal",
        components: {GenericUserInfo, GenericProfileInfo},
        props: {consultantId: {type: [Number], required: true}},
        data() {
            return {
                widgetReady: false,
                vm: {},
                contactId: 0,
                canEditCredentials: Boolean,
                emailConfirmed: Boolean
            };
        },
        methods: {
            async showModal({contactId, canEditCredentials = false}) {
                this.contactId = contactId;                
                await this.init();
            },
            async init() {
                let data = await api.getDataWithTwoIds("PsrContact", this.consultantId, "GetUserInfo", this.contactId);
                this.mapData('vm', data);
                this.canEditCredentials = await api.getDataWithTwoIds("Shared",this.consultantId ,"CanEditCredentials",this.vm.contactInfo.userId);
                this.emailConfirmed = this.vm.userInfo.isEmailConfirmed;
                this.widgetReady = true;
                this.$refs.modalRef.open();
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            async save() {
                let result = await api.post("PsrContact", "SaveUserInfoTab", this.vm);
                //console.log("Result of saving contact:", result);
                if (result) {
                    this.$refs.modalRef.close();
                    this.$bus.$emit(this.$bus.$AcEvents.CONTACT_CHANGE, result);
                }
            },
            async resetPassword() {
                api.post('Account', 'ForgotPassword', {email: this.vm.contactInfo.emailAddress});
            },
        }
    }
</script>

<style scoped>

</style>